// extracted by mini-css-extract-plugin
export default {"NewClassificationTypeDialog":"NewClassificationTypeDialog_NewClassificationTypeDialog__iY2lA"};